import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

enum SpinnerSizeEnum {
    Xs = 0,
    Sm,
    Md,
    Lg,
    Xl
}

type SpinnerColorType = 'white' | 'blue';

@Component({
    selector: 'spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent {
    @Input() public size: SpinnerSizeEnum = 1;
    @Input() public color: SpinnerColorType = 'white';

    get className(): string {
        return `size-${this.size} stroke-${this.color}`;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/spinner/spinner.component.ts